import { Link } from "react-router-dom";
import { t } from "../../lib/i18n";

/** items: [{label, to?}] – last item is current page. */
export const Breadcrumbs = ({ items = [], light = false, className = "" }) => (
  <nav aria-label={t("Brødsmulesti")} data-testid="breadcrumbs" className={`t-small ${className}`}>
    <ol className={`flex flex-wrap items-center gap-x-2.5 gap-y-1 ${light ? "text-white/70" : "text-muted"}`}>
      <li><Link to="/" className={`link-underline ${light ? "hover:text-white" : "hover:text-ink"}`}>EQVA</Link></li>
      {items.map((it, i) => (
        <li key={i} className="flex items-center gap-2.5">
          <span aria-hidden="true" className={light ? "text-white/40" : "text-[rgba(8,28,48,0.3)]"}>/</span>
          {it.to && i < items.length - 1 ? (
            <Link to={it.to} className={`link-underline ${light ? "hover:text-white" : "hover:text-ink"}`}>{it.label}</Link>
          ) : (
            <span aria-current="page" className={light ? "text-white" : "text-ink"}>{it.label}</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);
